import { Facility } from '@reliance/types/models/Facility';
import { VisitationBooth } from '@reliance/types/models/VisitationBooth';
import React from 'react';
import Button from 'react-bootstrap/Button';
import { IPaginatedResponse } from '../common/reliance-api-service';
import AddEditModal from './AddEditModal';
import Table from './Table';

type VisitationBoothListProps = {
  facility: Facility;
  visitationBooths: IPaginatedResponse<VisitationBooth> | null;
  showAddEditModal: boolean;
  editVisitationBooth: VisitationBooth | null;
  onAddClick(): void;
  onEdit(booth: VisitationBooth): void;
  onSave(data: Record<string, unknown>): Promise<unknown>;
  onClose(): void;
};

const VisitationBoothList: React.FC<VisitationBoothListProps> = (props) => {
  const {
    facility,
    visitationBooths,
    showAddEditModal,
    editVisitationBooth,
    onAddClick,
    onEdit,
    onSave,
    onClose,
  } = props;

  return (
    <>
      <Button onClick={onAddClick} variant="primary" className="mb-2">
        Add Visitation Booth
      </Button>

      <Table
        facility={facility}
        visitationBooths={visitationBooths}
        onEdit={onEdit}
      />

      {showAddEditModal && (
        <AddEditModal
          facility={editVisitationBooth?.facility ?? facility}
          visitationBooth={editVisitationBooth ?? undefined}
          onSave={onSave}
          onClose={onClose}
        />
      )}
    </>
  );
};

export default VisitationBoothList;
